module.exports = __webpack_public_path__ + "img/ico-7.d78bf12a.svg";